import { TenantsWithPropertiesDocument } from '@/graphql/tenants.generated'
import { gqlRequest } from '@/services/graphql'
import { nhost } from '@/lib/nhost'
import { getImpersonation } from '@/lib/impersonation'
import { mapTenantsWithProperties, switcherPropertiesWhere, type Tenant, type Property } from './tenant-mapping'

// Shapes + mapping live in the pure module (shared with the SSR header seed).
export type { Tenant, Property }

export async function fetchTenantsWithProperties(): Promise<Tenant[]> {
  // The request runs as the EFFECTIVE identity — the impersonation overlay when
  // active (browser authLink attaches the overlay token), else the real cookie
  // session — so the membership pin must use that same identity's id/role.
  const overlay = getImpersonation()
  const user = overlay ? overlay.user : nhost.getUserSession()?.user
  const response = await gqlRequest(TenantsWithPropertiesDocument, {
    propertiesWhere: switcherPropertiesWhere(user?.id, user?.defaultRole),
  })
  return mapTenantsWithProperties(response.body.data)
}
